// src/pages/AboutUS.jsx
import React, { Component } from "react";
import "../styles/AboutUS.css";
import "../App.css";
import { NavLink } from "react-router-dom";

import Footer from "./footer";
import ReachOutNow from "./ReachOut";

export default class Mission extends Component {
  state = {
    founderImageFailed: false,
  };

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  handleFounderImageError = () => {
    this.setState({
      founderImageFailed: true,
    });
  };

  render() {
    const { founderImageFailed } = this.state;

    const connectedCapabilities = [
      {
        number: "01",
        title: "Governance",
        description:
          "Connect occupational health and safety with executive accountability, strategy, enterprise risk, and organizational oversight.",
      },
      {
        number: "02",
        title: "Evidence",
        description:
          "Strengthen decisions through credible research, meaningful measures, evaluation, and evidence-informed improvement.",
      },
      {
        number: "03",
        title: "Technology",
        description:
          "Explore responsible applications of digital systems, AI, automation, immersive technology, and safer system design.",
      },
      {
        number: "04",
        title: "Learning",
        description:
          "Develop practical capability through customized, leadership-focused, scenario-based, and immersive learning.",
      },
      {
        number: "05",
        title: "Implementation",
        description:
          "Translate governance and strategy into practical priorities, operational action, and sustainable improvement.",
      },
    ];

    const currentContributions = [
      {
        number: "01",
        title: "BCRSP Board of Governors",
        description:
          "Supporting professional governance and the continued advancement of occupational health and safety practice.",
      },
      {
        number: "02",
        title: "World Assembly",
        description:
          "Contributing through the Founding Steering Committee and leading prevention-focused occupational health and safety metrics activity.",
      },
      {
        number: "03",
        title: "What Works Institute",
        description:
          "Providing strategic advisory support for evidence-informed leadership and practitioner collaboration.",
      },
      {
        number: "04",
        title: "Applied Research and Innovation",
        description:
          "Connecting academic, engineering, industry, learning, and technology expertise with practical safety challenges.",
      },
    ];

    const credentials = [
      "ICD.D",
      "CRSP since 2004",
      "BCRSP Board of Governors",
      "World Assembly Founding Steering Committee Member",
      "OSH Metrics Working Group Lead",
      "Canadian Occupational Top Women in Safety — 2023",
    ];

    return (
      <div className="aboutus-container about-gesi-page">
        <ReachOutNow />

        <main>
          {/* PAGE HERO */}
          <section
            className="about-gesi-hero parallax-image"
            aria-labelledby="about-gesi-hero-title"
          >
            <video
              className="aboutUS-image-img about-gesi-hero-video"
              autoPlay
              loop
              muted
              playsInline
              preload="auto"
              aria-label="GalaxyEDGE Safety background video"
            >
              <source src="/assets/HeroAboutUS.mp4" type="video/mp4" />

              Your browser does not support HTML5 video.
            </video>

            <div
              className="aboutus-hero-overlay about-gesi-hero-overlay"
              aria-hidden="true"
            ></div>

            <div className="about-gesi-hero-grid" aria-hidden="true"></div>

            <div className="about-gesi-hero-glow about-gesi-glow-left"></div>
            <div className="about-gesi-hero-glow about-gesi-glow-right"></div>

            <div className="about-gesi-hero-content Hero-text">
              <p className="about-gesi-kicker">
                About GalaxyEDGE Safety Inc.
              </p>

              <h1
                id="about-gesi-hero-title"
                className="about-gesi-hero-title heading"
              >
                Global Safety Innovation.
                <span> Grounded in Leadership.</span>
              </h1>

              <p className="about-gesi-hero-description">
                GalaxyEDGE Safety Inc. was founded to connect governance,
                evidence, technology, learning, and practical implementation
                through a more integrated approach to occupational health and
                safety.
              </p>

              <NavLink
                to="/contact"
                className="about-gesi-primary-button"
              >
                <span>Start a Conversation</span>

                <span
                  className="about-gesi-button-arrow"
                  aria-hidden="true"
                >
                  ↗
                </span>
              </NavLink>

              <div
                className="about-gesi-hero-path"
                aria-label="GalaxyEDGE Safety integrated approach"
              >
                <span>Governance</span>
                <span aria-hidden="true">+</span>
                <span>Evidence</span>
                <span aria-hidden="true">+</span>
                <span>Technology</span>
                <span aria-hidden="true">+</span>
                <span>Learning</span>
                <span aria-hidden="true">+</span>
                <span>Implementation</span>
              </div>
            </div>
          </section>

          {/* WHY GESI EXISTS */}
          <section
            className="about-gesi-purpose"
            aria-labelledby="about-gesi-purpose-title"
          >
            <div className="about-gesi-purpose-container">
              <div className="about-gesi-purpose-heading">
                <p className="about-gesi-section-kicker">
                  Why GESI Exists
                </p>

                <h2
                  id="about-gesi-purpose-title"
                  className="about-gesi-section-title"
                >
                  Built for a More
                  <span> Complex Safety Environment</span>
                </h2>
              </div>

              <div className="about-gesi-purpose-copy">
                <p>
                  Organizations are navigating more complex risk, rapid
                  technological change, rising expectations for psychological
                  health and wellbeing, and greater scrutiny of how safety is
                  governed.
                </p>

                <p>
                  GESI helps leaders respond with solutions that are credible,
                  practical, and built for the whole system.
                </p>

                <p>
                  The work combines executive-level advisory, customized
                  learning, applied research, digital innovation, integrated
                  systems, and strategic collaboration.
                </p>

                <p>
                  GESI brings together leaders, practitioners, engineers,
                  researchers, educators, and frontline stakeholders to
                  strengthen prevention and organizational resilience.
                </p>
              </div>

              <div className="about-gesi-capability-grid">
                {connectedCapabilities.map((capability) => (
                  <article
                    className="about-gesi-capability-card"
                    key={capability.title}
                  >
                    <span className="about-gesi-capability-number">
                      {capability.number}
                    </span>

                    <h3>{capability.title}</h3>

                    <p>{capability.description}</p>

                    <span
                      className="about-gesi-capability-line"
                      aria-hidden="true"
                    ></span>
                  </article>
                ))}
              </div>
            </div>
          </section>

          {/* INTEGRATED APPROACH */}
          <section
            className="about-gesi-approach"
            aria-labelledby="about-gesi-approach-title"
          >
            <div
              className="about-gesi-approach-background"
              aria-hidden="true"
            ></div>

            <div className="about-gesi-approach-container">
              <div
                className="about-gesi-approach-visual"
                aria-hidden="true"
              >
                <span className="about-gesi-approach-orbit about-gesi-approach-orbit-one"></span>

                <span className="about-gesi-approach-orbit about-gesi-approach-orbit-two"></span>

                <div className="about-gesi-approach-core">
                  <span>GESI</span>
                  <strong>Integrated</strong>
                  <small>Safety Innovation</small>
                </div>

                <span className="about-gesi-approach-label about-gesi-label-one">
                  Leadership
                </span>

                <span className="about-gesi-approach-label about-gesi-label-two">
                  Research
                </span>

                <span className="about-gesi-approach-label about-gesi-label-three">
                  Engineering
                </span>

                <span className="about-gesi-approach-label about-gesi-label-four">
                  Practice
                </span>
              </div>

              <div className="about-gesi-approach-content">
                <p className="about-gesi-section-kicker">
                  An Integrated Approach
                </p>

                <h2
                  id="about-gesi-approach-title"
                  className="about-gesi-section-title"
                >
                  Connect the Whole System,
                  <span> Not Only the Immediate Issue</span>
                </h2>

                <p>
                  GESI works across leadership, systems, learning, research,
                  technology, and implementation because safety performance is
                  influenced by the way these areas interact.
                </p>

                <p>
                  The objective is to help organizations move beyond isolated
                  activities toward stronger accountability, informed
                  decisions, practical execution, and continual learning.
                </p>

                <div className="about-gesi-approach-principle">
                  <span aria-hidden="true">✓</span>

                  <p>
                    Credible strategy must connect governance intent with the
                    realities of work, people, systems, evidence, and
                    implementation.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* FOUNDER SECTION */}
          <section
            className="about-founder"
            aria-labelledby="about-founder-title"
          >
            <div className="about-founder-background" aria-hidden="true">
              <span className="about-founder-glow"></span>
            </div>

            <div className="about-founder-container">
              <div className="about-founder-visual">
                <div
                  className={`about-founder-photo ${
                    founderImageFailed
                      ? "about-founder-photo-fallback"
                      : ""
                  }`}
                >
                  {!founderImageFailed && (
                    <img
                      src="/assets/LisaMcGuire.jpg"
                      alt="Lisa McGuire, Founder, President and CEO of GalaxyEDGE Safety Inc."
                      loading="lazy"
                      onError={this.handleFounderImageError}
                    />
                  )}

                  <span aria-hidden="true">LM</span>

                  <div
                    className="about-founder-photo-overlay"
                    aria-hidden="true"
                  ></div>
                </div>

                <div className="about-founder-nameplate">
                  <span>Founder, President &amp; CEO</span>

                  <strong>GalaxyEDGE Safety Inc.</strong>
                </div>
              </div>

              <div className="about-founder-content">
                <p className="about-gesi-section-kicker">
                  Founder and Chief Executive
                </p>

                <h2
                  id="about-founder-title"
                  className="about-founder-title"
                >
                  Lisa McGuire,
                  <span> CRSP, ICD.D</span>
                </h2>

                <div className="about-founder-biography">
                  <p>
                    Lisa McGuire is the Founder, President and CEO of
                    GalaxyEDGE Safety Inc. She brings more than 17 years of
                    executive leadership and 18 years of governance experience
                    to occupational health and safety strategy,
                    organizational transformation, professional capability,
                    and systems innovation.
                  </p>

                  <p>
                    As the former Founder and CEO of the Manufacturing Safety
                    Alliance of BC, Lisa led the organization through
                    significant growth and sector-level safety improvement.
                  </p>

                  <p>
                    Her work has included the development of practitioner
                    competency frameworks, harmonized management-system
                    approaches, executive leadership networks, immersive
                    learning initiatives, and international collaboration.
                  </p>

                  <p>
                    Lisa currently contributes through the BCRSP Board of
                    Governors, the World Assembly Founding Steering Committee
                    and OSH Metrics Working Group, strategic advisory work with
                    the What Works Institute, and applied research and
                    innovation partnerships.
                  </p>
                </div>

                <blockquote className="about-founder-principle">
                  <span aria-hidden="true">“</span>

                  <p>
                    Safety must be integrated into how organizations are
                    governed, how work is designed, and how people are enabled
                    to perform.
                  </p>
                </blockquote>

                <NavLink
                  to="/contact"
                  className="about-founder-button"
                >
                  <span>Connect with Lisa</span>

                  <span
                    className="about-founder-button-arrow"
                    aria-hidden="true"
                  >
                    ↗
                  </span>
                </NavLink>
              </div>
            </div>
          </section>

          {/* LEADERSHIP EXPERIENCE */}
          <section
            className="about-founder-experience"
            aria-labelledby="about-founder-experience-title"
          >
            <div className="about-founder-experience-container">
              <header className="about-gesi-centered-heading">
                <p className="about-gesi-section-kicker">
                  Leadership Experience
                </p>

                <h2
                  id="about-founder-experience-title"
                  className="about-gesi-section-title"
                >
                  Experience Across Leadership,
                  <span> Governance and Innovation</span>
                </h2>
              </header>

              <div className="about-founder-experience-grid">
                <article className="about-founder-experience-card">
                  <strong>17+</strong>

                  <h3>Years of Executive Leadership</h3>

                  <p>
                    Leading organizations, sector initiatives, strategic
                    growth, transformation, and occupational health and safety
                    improvement.
                  </p>

                  <span
                    className="about-founder-experience-line"
                    aria-hidden="true"
                  ></span>
                </article>

                <article className="about-founder-experience-card">
                  <strong>18</strong>

                  <h3>Years of Governance Experience</h3>

                  <p>
                    Contributing to board oversight, professional governance,
                    international initiatives, and organizational
                    accountability.
                  </p>

                  <span
                    className="about-founder-experience-line"
                    aria-hidden="true"
                  ></span>
                </article>

                <article className="about-founder-experience-card">
                  <strong>2004</strong>

                  <h3>CRSP Since</h3>

                  <p>
                    Demonstrating a long-standing professional commitment to
                    occupational health and safety leadership, practice, and
                    capability.
                  </p>

                  <span
                    className="about-founder-experience-line"
                    aria-hidden="true"
                  ></span>
                </article>
              </div>
            </div>
          </section>

          {/* CURRENT CONTRIBUTIONS */}
          <section
            className="about-founder-current"
            aria-labelledby="about-founder-current-title"
          >
            <div className="about-founder-current-container">
              <header className="about-gesi-centered-heading">
                <p className="about-gesi-section-kicker">
                  Current Contributions
                </p>

                <h2
                  id="about-founder-current-title"
                  className="about-gesi-section-title"
                >
                  Advancing Professional and
                  <span> International Collaboration</span>
                </h2>

                <p>
                  Lisa’s current work connects professional governance,
                  prevention-focused evidence, strategic advisory, applied
                  research, and emerging safety innovation.
                </p>
              </header>

              <div className="about-founder-current-grid">
                {currentContributions.map((contribution) => (
                  <article
                    className="about-founder-current-card"
                    key={contribution.title}
                  >
                    <span>{contribution.number}</span>

                    <h3>{contribution.title}</h3>

                    <p>{contribution.description}</p>

                    <span
                      className="about-founder-current-line"
                      aria-hidden="true"
                    ></span>
                  </article>
                ))}
              </div>
            </div>
          </section>

          {/* CREDENTIAL STRIP */}
          <section
            className="about-credentials"
            aria-label="Lisa McGuire credentials and professional contributions"
          >
            <div className="about-credentials-track">
              {credentials.map((credential, index) => (
                <React.Fragment key={credential}>
                  <span>{credential}</span>

                  {index < credentials.length - 1 && (
                    <i aria-hidden="true"></i>
                  )}
                </React.Fragment>
              ))}
            </div>
          </section>

          {/* FINAL CTA */}
          <section
            className="about-gesi-final"
            aria-labelledby="about-gesi-final-title"
          >
            <div className="about-gesi-final-background" aria-hidden="true">
              <span className="about-gesi-final-glow"></span>
              <span className="about-gesi-final-orbit"></span>
            </div>

            <div className="about-gesi-final-container">
              <p className="about-gesi-section-kicker">
                Work with GESI
              </p>

              <h2
                id="about-gesi-final-title"
                className="about-gesi-final-title"
              >
                Strengthen Safety Through
                <span> Connected Leadership and Action.</span>
              </h2>

              <p className="about-gesi-final-description">
                Connect with GESI to discuss an occupational health and safety
                challenge, leadership priority, learning need, research
                opportunity, technology concept, or strategic collaboration.
              </p>

              <NavLink
                to="/contact"
                className="about-gesi-primary-button"
              >
                <span>Start a Conversation</span>

                <span
                  className="about-gesi-button-arrow"
                  aria-hidden="true"
                >
                  ↗
                </span>
              </NavLink>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    );
  }
}